// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PVFx","index":"styles_index__2cifZ"};